"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentDetailsPanel = void 0;
var PaymentScheduleModalCms_cms_1 = require("./../components/panels/PaymentDetailsPanel/PaymentScheduleModal/PaymentScheduleModalCms.cms");
var PaymentDetailsPanel = /** @class */ (function () {
    function PaymentDetailsPanel() {
        this.paymentScheduleModalContent = new PaymentScheduleModalCms_cms_1.PaymentScheduleModalCms();
    }
    return PaymentDetailsPanel;
}());
exports.PaymentDetailsPanel = PaymentDetailsPanel;
//# sourceMappingURL=PaymentDetailsPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/cms/PaymentDetailsPanel.cms.js
// module id = 2270
// module chunks = 8